import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {UserService} from '../../services/user.service';
import {TranslateService} from '@ngx-translate/core';
import {PlaceholderVisibilityService} from '../../services/placeholder-visibility/placeholder-visibility.service';
import {WebUtils} from '../../utils/web.utils';

@Component({
  selector: 'sign-up',
  templateUrl: './influencer-sign-up.component.html',
  styleUrls: ['./influencer-sign-up.component.scss']
})
export class InfluencerSignUpComponent implements OnInit {

  public newUser: FormGroup;
  public isLogin: boolean;
  @Output() signUpSuccessCallback: EventEmitter<any> = new EventEmitter();
  passwordControl = new FormControl(undefined, {
    validators: this.validatePassword.bind(this),
    updateOn: 'blur'
  });

  confirmPasswordControl = new FormControl(undefined, {
    validators: this.validatePassword.bind(this),
    updateOn: 'blur'
  });

  constructor(private formBuilder: FormBuilder,
              private userService: UserService,
              private translate: TranslateService,
              private activatedRoute: ActivatedRoute,
              private placeholderService: PlaceholderVisibilityService) {
  }

  validatePassword() {
    if (!this.newUser) {
      return null;
    }
    const password = this.newUser.controls.password.value;
    const confirmPassword = this.newUser.controls.confirmPassword.value;
    if (!confirmPassword && !password) {
      return null;
    }

    if (confirmPassword !== password) {
      return {
        doesMatchPassword: false
      };
    }
    return null;
  }

  ngOnInit() {
    this.newUser = this.formBuilder.group({
      fullName: [ null,  Validators.required ],
      email: [ null ],
      password: this.passwordControl,
      confirmPassword: this.confirmPasswordControl,
      acceptTermService: [ null ]
    });
  }

  showConfirmBox() {
    this.isLogin = false;
  }

  showLoginBox() {
    this.isLogin = true;
  }

}



// WEBPACK FOOTER //
// ./src/app/influencer-auth/influencer-sign-up/influencer-sign-up.component.ts